import type { Ref } from 'react';
import React from 'react';
import type { LinkProps as MuiLinkProps } from '@mui/material';
import { Link as MuiLink } from '@mui/material';
import type { LinkProps as RouterLinkProps } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

type Props = MuiLinkProps & RouterLinkProps;

const MuiRouterLink = (props: Props, ref: Ref<any>) => (
    <MuiLink component={RouterLink} ref={ref} {...props} />
);

export default React.forwardRef(MuiRouterLink);
